import * as React from 'react';
import styles from './subheader.module.css';

type Props = {
    children?: React.ReactNode;
    as: string;
};

Subheader.defaultProps = {
    as: 'span',
};

export function Subheader({children, as: Tag}: Props) {
    // @ts-expect-error
    return <Tag className={styles['header']}>{children}</Tag>;
}
